<p-toolbar>
  <ng-template #start>
    <div class="flex items-center space-x-2 toolbar-menu">
      <p-select
        [options]="singleMultiple"
        [ngModel]="selectedSingleMultiple"
        (onChange)="onModeChanged($event.value)"
        appendTo="body"
      ></p-select>

      @if (selectedSingleMultiple === 'multipleOperation' && phaseEnvelopes?.length > 0) {
        <p-select
          [options]="phaseEnvelopes"
          [ngModel]="selectedPhaseEnvelope"
          (onChange)="onPhaseEnvelopeChanged($event.value)"
          optionLabel="fluid.state.name"
          appendTo="body"
        ></p-select>
      }

      @if (selectedSingleMultiple === 'singleOperation') {
        <p-selectButton
          [options]="resultsDisplay"
          [ngModel]="selectedResultsDisplay"
          (onChange)="onResultsDisplayChanged($event.value)"
          [allowEmpty]="false"
        ></p-selectButton>
      }

      @if (selectedResultsDisplay === 'grid') {
        <p-selectButton
          [options]="envelopeOperation"
          [ngModel]="selectedEnvelopeOperation"
          (onChange)="onEnvelopeOperationChanged($event.value)"
          [allowEmpty]="false"
        ></p-selectButton>
      }
    </div>
  </ng-template>

  <ng-template #end>
    <div class="flex space-x-2 pr-2 pt-1">
      @if (selectedSingleMultiple === 'singleOperation') {
        <p-select
          [options]="operations"
          [ngModel]="selectedOperation"
          (onChange)="onOperationChanged($event.value)"
          optionLabel="name"
          appendTo="body"
        ></p-select>
      }

      @if (selectedSingleMultiple === 'singleOperation') {
        <p-button
          outlined="true"
          size="small"
          [disabled]="moveUpDisabled"
          (onClick)="onMoveRequested('up')"
          icon="pi pi-arrow-up"
        ></p-button>
      }

      @if (selectedSingleMultiple === 'singleOperation') {
        <p-button
          outlined="true"
          size="small"
          [disabled]="moveDownDisabled"
          (onClick)="onMoveRequested('down')"
          icon="pi pi-arrow-down"
        ></p-button>
      }
    </div>
  </ng-template>
</p-toolbar>
